import cn from "classnames";
import { useStyles } from "./styles";

import shadowImage from "src/assets/shadow.svg";
import { useHistory } from "react-router-dom";

interface INavItemProps {
    icon: string;
    label: string;
    to: string;
    active?: boolean;
    available: boolean;
}

export const NavItem = ({
    to,
    icon,
    label,
    active,
    available,
}: INavItemProps) => {
    const styles = useStyles();
    const history = useHistory();

    const onRedirect = () => {
        available && history.push(to);
    };

    return (
        <div
            className={cn(styles.wrapper, { active, [styles.unavailable]: !available })}
            onClick={onRedirect}
        >
            <div className={styles.imageBox}>
                <img
                    src={icon}
                    className={cn(styles.icon, available && "icon")}
                    alt={`side_icon_${label}`}
                />
                <img
                    src={shadowImage}
                    className={cn(styles.iconShadow, available && "iconShadow", { active })}
                />
            </div>
            <span className={styles.label}>{label}</span>
        </div>
    );
};
